import {
  changeDayInGivenDate,
  getCurrentMonthDate,
  getDateOfCurrentWeekDay,
  getDateOfNextWeek,
  getNextMonthDate,
  isCurrentOrFutureDayOfWeek,
  isFutureDay,
  isFutureDayOfWeek,
  isFutureOrCurrentDay
} from '@utils/date';

import { MonthDay } from './constants';

export const isFirstDayFrequencyEquivalent = (date?: Date | string) => {
  if (!date) return false;
  if (date === MonthDay.LAST) return false;
  if (date === MonthDay.FIRST || String(date) === '1') return true;
  if (!(date instanceof Date)) return false;
  return date.getDate() === 1;
};

export const handleMonthDateSelect = (props: {
  item: string;
  date?: Date;
  isPaymentLinkSent?: boolean;
}) => {
  const startDate = props.date || new Date();
  let nextDueDate;
  if (props.isPaymentLinkSent) {
    nextDueDate = getNextMonthDate(props.item, startDate);
  } else if (isFutureOrCurrentDay(props.item, startDate)) {
    nextDueDate = getCurrentMonthDate(props.item, startDate);
  } else {
    nextDueDate = getNextMonthDate(props.item, startDate);
  }
  const isFutureDate = isFutureDay(props.item, startDate);
  return { nextDueDate: new Date(nextDueDate), isFutureDate };
};

export const handleWeekDateSelect = (
  id: number,
  date?: Date,
  isPaymentLinkSent?: boolean
) => {
  const startDate = date || new Date();
  let nextDueDate;
  if (isPaymentLinkSent) {
    nextDueDate = getDateOfNextWeek(id, startDate);
  } else if (isCurrentOrFutureDayOfWeek(id, startDate)) {
    nextDueDate = getDateOfCurrentWeekDay(id, startDate);
  } else {
    nextDueDate = getDateOfNextWeek(id, startDate);
  }
  const isFutureDate = isFutureDayOfWeek(id, startDate);
  return { nextDueDate: new Date(nextDueDate), isFutureDate };
};

export const handleTermDateSelect = ({
  nextDueDate,
  item,
  date
}: {
  nextDueDate?: string;
  item: string;
  date?: Date;
}) => {
  let modifiedDueDate;
  const startDate = date || new Date();
  const isDueMonth = nextDueDate
    ? new Date(nextDueDate).getMonth() === new Date().getMonth()
    : false;
  if (nextDueDate && !isDueMonth) {
    modifiedDueDate = changeDayInGivenDate(new Date(nextDueDate), item);
  } else if (isFutureOrCurrentDay(item, startDate)) {
    modifiedDueDate = getCurrentMonthDate(item, startDate);
  } else {
    modifiedDueDate = getNextMonthDate(item, startDate);
  }
  return new Date(modifiedDueDate);
};
